<template>
  <div>
    <modal size="lg" :show.sync="openEntity" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        Add Entity ID
      </h6>
      <VoiceBlastTemplateEntity />
      <template slot="footer">
        <base-button type="primary">Create New Entity</base-button>
        <base-button
          type="secondary"
          class="ml-auto"
          @click="openEntity = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <div class="flex items-center cursor-pointer">
      <feather-icon icon="ChevronLeftIcon" class="mr-2"></feather-icon>
      <p class="font-semibold">Back</p>
    </div>

    <div class="mt-8">
      <div class="flex">
        <div class="min-w70 pr-3">
          <div class="mb-4">
            <base-input
              class="w-full"
              label="Template Name"
              placeholder="Enter Template Name"
            >
            </base-input>
          </div>

          <base-input class="w-full" label="Template Message">
            <textarea
              class="form-control"
              id="exampleFormControlTextarea3"
              rows="3"
            ></textarea>
          </base-input>

          <div class="flex justify-between mb-4" >
            <b-form-checkbox
              id="checkbox-1"
              v-model="status"
              name="checkbox-2"
              value="accepted"
              unchecked-value="not_accepted"
              class="w-1/2 custom-control-inline"
            >
              <p class="font-semibold text-lg">is keypress</p>
            </b-form-checkbox>
            <b-form-checkbox
              class="w-1/2 custom-control-inline"
              id="checkbox-2"
              v-model="status"
              name="checkbox-2"
              value="accepted"
              unchecked-value="not_accepted"
            >
              <p class="font-semibold text-lg">is Repeat</p>
            </b-form-checkbox>
          </div>

          <div class="mb-4">
            <base-input class="w-full" label="Repeat Keypress">
              <select class="form-control">
                <option disabled="true">Select</option>
                <option>A</option>
                <option>B</option>
              </select>
            </base-input>
          </div>

          <div class="mb-4">
            <base-input
              class="w-full"
              label="Call Patch Number"
              placeholder="Enter Patch Number"
            >
            </base-input>
          </div>

       
          <div class="mb-4">
            <base-input class="w-full" label="Call Patch Keypress">
              <select class="form-control">
                <option disabled="true">Select Call Patch</option>
                <option>A</option>
                <option>B</option>
              </select>
            </base-input>
          </div>
    

       
          <base-button block type="primary" class="text-lg mt-8"
            >Create Template</base-button
          >
        </div>

        <div class="min-w30 pl-3">
                 <b-card no-body class="rounded-xl p-3 mb-4">
            <b-card-text
              class="
                font-semibold
                text-primary
                border-bottom
                pb-2
                cursor-pointer
              "
              >Useful Links</b-card-text
            >


            <div class="p-2 mt-2">
<p>1.<span class="font-semibold pl-1 text-sm cursor-pointer">How to Create Voice Template</span></p>
<p>2.<span class="font-semibold pl-1 text-sm cursor-pointer">How to Use Voice Template</span></p>
<p>3.<span class="font-semibold pl-1 text-sm cursor-pointer">How to Use Voice Varibalee</span></p>
<p>4.<span class="font-semibold pl-1 text-sm cursor-pointer">How to Save or Choose SMS Template</span></p>

</div>
          </b-card>
          <b-card no-body class="rounded-xl p-3">
            <b-card-text
              class="
                font-semibold
                text-primary
                border-bottom
                pb-2
                cursor-pointer
              "
              >Variables In Template</b-card-text
            >
            <b-card-body></b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VoiceBlastTemplateEntity from "./VoiceBlastTemplateEntity";

export default {
  data() {
    return {
      openEntity: false,
    };
  },
  components: {
    VoiceBlastTemplateEntity,
  },
};
</script>
